export default __webpack_public_path__ + "static/media/pwa0.95c5ada9.jpg";